var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDurationSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7177734,10.78125c0.3837891,0,0.7685547-0.1464844,1.0605469-0.4384766 c0.5849609-0.5849609,0.5849609-1.5361328,0-2.1210938c-0.5839844-0.5839844-1.5371094-0.5839844-2.1210938,0 c-0.5849609,0.5849609-0.5849609,1.5361328,0,2.1210938C21.9492188,10.6347656,22.3339844,10.78125,22.7177734,10.78125z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 16,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6572266,21.6572266c-0.5849609,0.5849609-0.5849609,1.5361328,0,2.1210938 c0.2919922,0.2919922,0.6767578,0.4384766,1.0605469,0.4384766s0.7685547-0.1464844,1.0605469-0.4384766 c0.5849609-0.5849609,0.5849609-1.5361328,0-2.1210938C23.1943359,21.0732422,22.2412109,21.0732422,21.6572266,21.6572266z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 25.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2216797,21.6572266c-0.5849609,0.5849609-0.5849609,1.5361328,0,2.1210938 c0.2919922,0.2919922,0.6767578,0.4384766,1.0605469,0.4384766s0.7685547-0.1464844,1.0605469-0.4384766 c0.5849609-0.5849609,0.5849609-1.5361328,0-2.1210938C9.7587891,21.0732422,8.8056641,21.0732422,8.2216797,21.6572266z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 16,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2216797,8.2216797c-0.5849609,0.5849609-0.5849609,1.5361328,0,2.1210938 C8.5136719,10.6347656,8.8984375,10.78125,9.2822266,10.78125s0.7685547-0.1464844,1.0605469-0.4384766 c0.5849609-0.5849609,0.5849609-1.5361328,0-2.1210938C9.7587891,7.6376953,8.8056641,7.6376953,8.2216797,8.2216797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,1C7.7285156,1,1,7.7285156,1,16s6.7285156,15,15,15s15-6.7285156,15-15S24.2714844,1,16,1z M16,29 C8.8320312,29,3,23.1679688,3,16S8.8320312,3,16,3s13,5.8320312,13,13S23.1679688,29,16,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,18h6v-2h-6v-6h-2v6C14,17.1025391,14.8974609,18,16,18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationSmall);
export default __webpack_public_path__ + "static/media/duration--small.baaf2970eb2fa136811a8d7686b8f84c.svg";
export { ForwardRef as ReactComponent };